<template>
    <div>

        
        <el-form>
            <el-row :gutter="10" class="u-mt-10 u-mb-20">
                <el-col :xs="24" :sm="18" :md="18">
                    <el-form-item key="curso_id">
                        <el-select @change="getTurmas()" label="Modalidade/Curso" v-model="filtro.curso_id" filterable placeholder="Selecionar Modalidade/Curso">
                            <el-option v-for="(item, i) in selectCursos" :key="i" :label="item.nome" :value="item.id"> </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="6" :md="6">
                    <el-form-item key="Turma">
                        <el-select @change="getMatriculasByTurma()" label="Turma" v-model="filtro.turma_id" filterable placeholder="Selecionar Modalidade/Curso">
                            <el-option v-for="(item, i) in selectTurmas" :key="i" :label="item.nome" :value="item.id"> </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <el-form>
            <el-row :gutter="10" class="u-mt-10 u-mb-20">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-select @change="selecionaTodos()" v-if="filtro.curso_id && filtro.turma_id" v-model="todos" filterable placeholder="Marcar todos como aprovado">
                        <el-option label="" value=""></el-option>
                        <el-option label="APROVADO" :value="1"></el-option>
                    </el-select>
                </el-col>
            </el-row>
        </el-form>

        <div class="container-table">
            <table v-loading="!statusList" class="table table-striped">
                <thead>
                    <tr>
                        <th>Matrícula</th>
                        <th>Modalidade/Curso 2023</th>
                        <th>Aluno</th>
                        <th class="u-text-center">Data de Nascimento</th>
                        <th class="u-text-center" style="width: 150px;">
                            Situação Acadêmica
                        </th>
                        <th class="u-text-center" style="width: 300px;">
                            Nova Enturmação em 2024
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, i) in matriculas" :key="i">
                        <td>{{ item.num_matricula }}</td>
                        <td>{{ item.curso.nome }}</td>
                        <td>{{ item.aluno.nome }}</td>
                        <td class="u-text-center">{{ $moment(item.aluno.data_nascimento).format('DD/MM/YYYY') }}</td>
                        <td class="select-situacao-academica">
                            <el-select @change="situacaoAlterada(item.id, i)" v-if="!dados[item.id].status" v-model="dados[item.id].situacao_academica" v-bind:class="{ conservado: dados[item.id].situacao_academica >= 2 && dados[item.id].situacao_academica <= 5, aprovado: dados[item.id].situacao_academica == 1 }" filterable placeholder="" class="select-text-center">
                                <template v-for="(item, j) in $CONSTANTS.SITUACAO_ACADEMICA">
                                    <el-option v-if="j != 0 && j != 6 && j != 5" :key="j" :label="item" :value="parseInt(j)"></el-option>
                                </template>
                            </el-select>
                            <div v-if="dados[item.id].status" class="disabled">
                                {{ $CONSTANTS.SITUACAO_ACADEMICA[item.situacao_academica] }}
                            </div>
                        </td>
                        <td class="select-situacao-academica">
                            <template v-if="dados[item.id] && Object.keys(dados[item.id].options).length !== 0 && dados[item.id].situacao_academica != 0 && dados[item.id].situacao_academica != 1">
                                <el-select v-model="dados[item.id].turma_id" class="select-text-center">
                                    <el-option-group v-for="(curso, i) in dados[item.id].options.turmas" :key="i" :label="i">
                                        <template v-for="itemc in curso">
                                        <el-option :key="itemc.id" :label="itemc.curso_nome + ' - ' + itemc.nome" :value="itemc.id"></el-option>
                                        </template>
                                    </el-option-group>
                                </el-select>
                            </template>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr v-if="statusList && matriculas.length == 0" style="border-top: 1px solid #ddd;">
                        <td colspan="100%" class="u-text-center">
                            <span>- nenhum registro -</span>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
        <el-row :gutter="10" v-if="statusButton && matriculas.length != 0">
            <el-col :xs="24" class="u-text-right u-mt-15">
                <el-button type="primary" @click="onSubmitSituacaoAcademica()">SALVAR</el-button>
            </el-col>
        </el-row>

        <el-dialog append-to-body :close-on-click-modal="false" title="ATENÇÃO" width="30%" :visible.sync="dialogAlerta">
            <div v-if="dialogAlerta">
                
                <div style="margin: 20px 0px; font-size: 16px;">
                    
                        Atenção!<br><br>

                        Existem alunos que já tiveram suas matrículas renovadas e que não foram aprovados. 
                        
                        É necessário realizar uma nova enturmação para estes alunos.

                        Você poderá obter mais detalhes assistindo ao vídeo abaixo.

                </div>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        
                        <div class='embed-container'>
                            <iframe src='https://www.youtube.com/embed/GYLIaCF5Mmc' frameborder='0' allowfullscreen></iframe>
                        </div>

                    </el-col>
                </el-row>
            </div>
        </el-dialog>

    </div>
</template>
<script>

import Vue from 'vue'

export default {
    data: () => ({
        dialogAlerta: false,
        statusButton: false,
        statusList: true,
        filtro: {
            curso_id: '',
            turma_id: ''
        },
        dados: {},
        selectCursos: [],
        selectTurmas: [],
        matriculas: [],
        todos: ''
    }),
    mounted(){
        
      this.getCursosByInstituicao()
    },
    methods: {
        selecionaTodos(){

            for(let i in this.dados){

                if(!this.dados[i].status){
                    
                    this.dados[i].turma_id = '';
                    this.dados[i].situacao_academica = this.todos;
                    this.dados[i].options = {};
                }
            }
        },
        situacaoAlterada(ref, i){

            this.dados[ref].turma_id = '';
            this.dados[ref].options = {};

            //SE CONSERVADO, EVADIDO, DESISTENTE OU FALECIDO
            if(this.dados[ref].situacao_academica == 2 || this.dados[ref].situacao_academica == 3 || this.dados[ref].situacao_academica == 4 || this.dados[ref].situacao_academica == 5){

                this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getAllForUpdateSituacaoAcademica/${this.matriculas[i].id}`, this.$store.getters.getHeaderAuth).then(response => {

                    this.dados[ref].options = response.data;

                }).catch((error) => { this.$store.commit('throwException', error); });

            }else{
                
                this.dados[ref].options = {};
            }

        },
        getCursosByInstituicao(){

            let i = this.$store.state.config.instituicao.id;
            let p = this.$store.state.config.parametros.periodo_letivo_situacao_academica;

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/curso/getCursosInstituicao/` + i +'/' + p, this.$store.getters.getHeaderAuth).then(response => {

                this.selectCursos = response.data;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        getTurmas(){

            this.todos = '';
            this.matriculas = [];
            this.filtro.turma_id = '';

            window.eventBus.$emit('loading', true);

            let i = this.$store.state.config.instituicao.id;
            let p = this.$store.state.config.parametros.periodo_letivo_situacao_academica;

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getAllTurmasByCursos/` + i + '/' + p + '/' + this.filtro.curso_id, this.$store.getters.getHeaderAuth).then(response => {

                this.selectTurmas = response.data;
                window.eventBus.$emit('loading', false);
 
            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
        },
        getMatriculasByTurma(){

            this.todos = '';
            this.statusList = false;

            this.dados = {};
            this.matriculas = [];

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/matricula/getAllByTurmaForSituacaoAcademica/` + this.filtro.turma_id, this.$store.getters.getHeaderAuth).then(response => {
                
                for(let i in response.data){
                    Vue.set(this.dados, response.data[i].id, { status: (response.data[i].situacao_academica ? true : false), turma_id: '', situacao_academica: '', options: {} });
                }       
                
                this.matriculas = response.data;
                this.statusList = true;
                this.statusButton = true;
 
            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
        },
        onSubmitSituacaoAcademica(){

            for(let i in this.dados){

                if(((
                    this.dados[i].situacao_academica == 2 || 
                    this.dados[i].situacao_academica == 3 || 
                    this.dados[i].situacao_academica == 4 || 
                    this.dados[i].situacao_academica == 5 ) &&
                    Object.keys(this.dados[i].options).length !== 0 &&
                    this.dados[i].options.turmas.length == 0 ) ||
                    (
                        Object.keys(this.dados[i].options).length !== 0 &&
                        this.dados[i].options.turmas.length != 0 &&
                        !this.dados[i].turma_id
                    )
                ){      
                    
                    this.dialogAlerta = true;
                    return false;
                }

            }
           
            this.$msgbox.confirm('Tem certeza que deseja continuar?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                window.eventBus.$emit('loading', true);
                    
                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/diario-online/storeSituacaoAcademica`, this.dados, this.$store.getters.getHeaderAuth).then(response => {
                            
                    if(typeof response.data.erro !== 'undefined'){

                        window.eventBus.$emit('alert', {msg: response.data.erro, type: 'warning'});
                        window.eventBus.$emit('loading', false);

                    }else{

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        this.getMatriculasByTurma();
                    }
                    

                    
                    
                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});
           
        }
    }
}
</script>
<style>

    .select-situacao-academica{
        padding: 0px !important;
    }

    .select-situacao-academica .conservado .el-input__inner{
        
        background-color: #ffc5c5;
        color: #313131;
    }

    .select-situacao-academica .aprovado .el-input__inner{
        
        background-color: #99ff99;
        color: #313131;
    }

    .select-situacao-academica .transferido .el-input__inner{
        
        background-color: #f3ea87;
        color: #313131;
    }

    .select-situacao-academica .el-input__inner::placeholder{
        
        color: #313131;
    }

    .select-situacao-academica .disabled{
        
        text-align: center;
        border-left: 1px solid #cccccc;
        border-right: 1px solid #cccccc;
        height: 30px;
        /* padding-left: 15px; */
        line-height: 36px;
        background-color: #e3e3e3;
    }

    .select-text-center .el-input__inner{
        text-align: center !important;
    }

  
</style>